export default __webpack_public_path__ + "static/media/options-icon.cb968d76.svg";